import { render } from "./Actions.vue?vue&type=template&id=3b5ec8fd&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"

import "./Actions.vue?vue&type=style&index=0&id=3b5ec8fd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b5ec8fd"

export default script